import { Controller } from "@hotwired/stimulus"

// Native named, form-associated checkboxes submit the selection. Stimulus
// supplies select-all and empty-selection button feedback under the nonce CSP.
export default class extends Controller {
  static targets = ["selectAll", "checkbox", "button"]

  connect() {
    this.sync()
  }

  // Select-All checkbox → mirror its state onto every row checkbox.
  toggleAll() {
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = this.selectAllTarget.checked
    })
    this.sync()
  }

  // Refresh optional browser feedback without changing submitted controls.
  sync() {
    const checked = this.checkboxTargets.filter((checkbox) => checkbox.checked)

    if (this.hasButtonTarget) {
      this.buttonTarget.disabled = checked.length === 0
    }
  }
}
